import { Icon, Label } from 'semantic-ui-react';

interface IProps {
  platformReady?: boolean;
}

export function PlatformReadyLabel({ platformReady }: IProps) {
  if (!platformReady) {
    return null;
  }

  return (
    <Label basic color="green">
      <Icon name="check" />
      &nbsp; Platform Ready
    </Label>
  );
}
